export const COMFORT_PERSIST_KEY = "Reports-comfort";

export const VIEW_BY_OPTIONS = [
  {
    value: "hoursDiscomfort",
    label: "Total hours uncomfortable",
    sub: "Total hours",
  },
  {
    value: "pctDiscomfort",
    label: "% of occupied hours uncomfortable",
    sub: "% of occuppied hours",
  },
];

export const ORDER_BY_OPTIONS = [
  { value: "worst", label: "Worst performing" },
  { value: "best", label: "Best performing" },
];

export const TRACKING_EVENT_TIME_FRAME =
  "Selected Time Frame (Comfort Reports)";
export const TRACKING_EVENT_SORT_BY = "Chart - Sorted DataGrid";
export const TRACKING_EVENT_GROUP_BY = "Chart - Clicked GroupBy";
export const TRACKING_EVENT_ORDER_BY = "Chart - Clicked OrderBy";
export const TRACKING_EVENT_CHART_CLICK = "Chart - Clicked Chart element";
